import { features } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1100px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            平台优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么数百万影迷选择蚂蚁影视？三大核心优势告诉你答案
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 text-center hover:border-primary-200 transition-all cursor-default"
            >
              <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
                <i className={`${feature.icon} text-2xl`}></i>
              </div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}